export default __webpack_public_path__ + "static/media/fb.0fae119f.svg";